import ProfileItemForm from "./ProfileItemForm";
import { FormInputComponent } from "../../../components/form/Form";
import ProfileReferenceRow from "../../profiles/components/ProfileReferenceRow";
import {
    canonicalLinkedInProfileUrl,
    linkedInProfileUrlRule
} from "../../../components/form/linkedInProfileUrl";
import { TalentAppCard } from './TalentAppCard';
import { Input } from "antd";

export default class ReferenceForm extends ProfileItemForm {

    static ItemType = 'Reference'

    static FormClass = 'talent-role-form talent-interest-form add-talent-form '

    static ShowProfilePreview = false;

    static shouldUseTalentAppCard = true;


    // static TypeConfig = {
    //     icon: 'fas fa-handshake',
    //     color: '#aaacad'
    // }

    // canEdit() {
    //     return !this.props.model?.is_confirmed;
    // }

    getModelFromProps() {
        return this.props.model || {};
    }


    /**
     * Confirm deletion
     */
    async onDelete() {
        if (!this.props.user?.isApplicationApproved() && this.props.user.talent_references?.length <= 1) {
            return TB.alert(
                'error',
                `Minimum # of References Required`,
                'You must have at least 2 references. If you want to remove this reference, add another one first and then try again.'
            )
        }

        return super.onDelete();
    }
    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model = {}) {
        return this.setState({ model: { ...this.getModelFromProps(), ...model } })
    }

    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     */
    onSubmit() {
        let model = {
            ...this.state.model
        };

        // Store the canonical profile URL rather than whatever was pasted in
        let canonical = canonicalLinkedInProfileUrl(model.linkedin_profile_url);
        if (canonical) {
            model.linkedin_profile_url = canonical;
        }

        return super.onSubmit(model);
    }
    /**
     * The fields mapping for the form
     */
    // formFields_LEGACY = () => {
    //     let otherUserReferences = TB.filter(this.props.user.talent_references || [], ref => !!ref.id && ref.id !== this.props.model.id);

    //     let emailsTaken = TB.map(otherUserReferences, 'email');
    //     let linkedInsTaken = TB.filter(
    //         TB.map(otherUserReferences, ref => canonicalLinkedInProfileUrl(ref.linkedin_profile_url)),
    //         url => !!url
    //     );
    //     if (this.props.model?.is_confirmed) return null;
    //     return [
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 first_name: {
    //                     style: styles.field,
    //                     columns: 6,
    //                     component: (
    //                         <FormInputComponent
    //                             type="text"
    //                             maxLength={255}
    //                             fieldName="first_name"
    //                             required={true}
    //                             value={this.state.model.first_name}>
    //                         </FormInputComponent>
    //                     )
    //                 },
    //                 last_name: {
    //                     style: styles.field,
    //                     columns: 6,
    //                     component: (
    //                         <FormInputComponent
    //                             type="text"
    //                             maxLength={255}
    //                             fieldName="last_name"
    //                             required={true}
    //                             value={this.state.model.last_name}>
    //                         </FormInputComponent>
    //                     )
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 email: {
    //                     style: styles.field,
    //                     columns: 6,
    //                     component: (
    //                         <FormInputComponent
    //                             type="email"
    //                             maxLength={255}
    //                             fieldName="email"
    //                             required={true}
    //                             validation={{
    //                                 rules: {
    //                                     isEmail: true,
    //                                     emailsTaken: function (model, value) {
    //                                         if (emailsTaken.includes(value)) {
    //                                             return "Reference email already used"
    //                                         }
    //                                         return true
    //                                     },
    //                                 },

    //                             }}
    //                             value={this.state.model.email}>
    //                         </FormInputComponent>
    //                     )
    //                 },
    //                 linkedin_profile_url: {
    //                     style: styles.field,
    //                     columns: 6,
    //                     component: (
    //                         <FormInputComponent
    //                             type="url"
    //                             maxLength={255}
    //                             label={`${TB.trans('talent.bio.linkedin_profile_url_label')} (Include https://)`}
    //                             placeholder={TB.trans('talent.bio.linkedin_profile_url_placeholder')}
    //                             fieldName="linkedin_profile_url"
    //                             required={true}
    //                             validation={{
    //                                 rules: {
    //                                     isLinkedInProfileUrl: linkedInProfileUrlRule,
    //                                     linkedInsTaken: function (model, value) {
    //                                         if (linkedInsTaken.includes(canonicalLinkedInProfileUrl(value))) {
    //                                             return "Reference LinkedIn already used"
    //                                         }
    //                                         return true
    //                                     },
    //                                 },
    //                             }}
    //                             value={this.state.model.linkedin_profile_url}>
    //                         </FormInputComponent>
    //                     )
    //                 }
    //             },
    //         }
    //     ];
    // };

    renderFormFooterInfo() {
        return <div />
    }

    renderEditFormButton() {
        return (
            <button
                className="btn btn-primary px-6"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}
            >
                Edit Reference
            </button>
        );
    }


    renderFormFields() {
        const { isEditing, disabled } = this.props;

        if (isEditing) {
            return (
                <TalentAppCard.Section>
                    {this.renderFormData()}
                </TalentAppCard.Section>
            )
        }

        return (
            <TalentAppCard.Section>
                {this.renderFormattedData()}
            </TalentAppCard.Section>
        )
    }

    renderFormData = () => {
        let otherUserReferences = TB.filter(this.props.user.talent_references || [], ref => !!ref.id && ref.id !== this.props.model.id);

        let emailsTaken = TB.map(otherUserReferences, 'email');
        let linkedInsTaken = TB.filter(
            TB.map(otherUserReferences, ref => canonicalLinkedInProfileUrl(ref.linkedin_profile_url)),
            url => !!url
        );

        return (
            <div className="flex flex-col gap-y-4 gap-x-6">
                <div className="flex flex-col sm:flex-row gap-4 [&_.invalid-feedback]:!m-0 [&_.form-group]:!m-0">
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            maxLength={255}
                            fieldName="first_name"
                            required={true}
                            value={this.state.model.first_name}
                        >
                            <Input
                                placeholder="First Name"
                                disabled={this.props.disabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            maxLength={255}
                            fieldName="last_name"
                            required={true}
                            value={this.state.model.last_name}
                        >
                            <Input
                                placeholder="Last Name"
                                disabled={this.props.disabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 [&_.invalid-feedback]:!m-0 [&_.form-group]:!m-0">
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            maxLength={255}
                            fieldName="email"
                            required={true}
                            validation={{
                                rules: {
                                    isEmail: true,
                                    emailsTaken: function (model, value) {
                                        if (emailsTaken.includes(value)) {
                                            return "Reference email already used"
                                        }
                                        return true
                                    },
                                },
                            }}
                            value={this.state.model.email}
                        >
                            <Input
                                placeholder="Email"
                                disabled={this.props.disabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            maxLength={255}
                            label={`${TB.trans('talent.bio.linkedin_profile_url_label')} (Include https://)`}
                            fieldName="linkedin_profile_url"
                            required={true}
                            validation={{
                                rules: {
                                    isLinkedInProfileUrl: linkedInProfileUrlRule,
                                    linkedInsTaken: function (model, value) {
                                        if (linkedInsTaken.includes(canonicalLinkedInProfileUrl(value))) {
                                            return "Reference LinkedIn already used"
                                        }
                                        return true
                                    },
                                },
                            }}
                            value={this.state.model.linkedin_profile_url}
                        >
                            <Input
                                placeholder={TB.trans('talent.bio.linkedin_profile_url_placeholder')}
                                disabled={this.props.disabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                </div>
            </div>
        )
    }

    renderTitle() {
        return null;
    }

    renderFormattedData() {
        const { id, is_confirmed, is_recommended, comments, linkedin_profile_url, image_path, first_name, last_name, email } = this.state.model;

        const referenceIndex = this.props.talent_references.findIndex(reference => reference.id === id);

        return (
            <div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4">
                    <h3 className="text-base font-semibold m-0">
                        Reference #{referenceIndex + 1}
                    </h3>
                    {!!id && (
                        <span className={`inline-block self-start text-xs font-medium px-2.5 py-1 rounded-full ${is_confirmed
                                ? 'bg-green-100 text-green-800'
                                : 'bg-yellow-100 text-yellow-800'
                            }`}>
                            {is_confirmed ? 'Confirmed' : 'Pending'}
                        </span>
                    )}
                </div>

                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
                    <div className="shrink-0">
                        <img
                            src={image_path || '/images/alt_user.png'}
                            alt={`${first_name} ${last_name} profile`}
                            className="h-[52px] w-[52px] rounded-full object-cover"
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row flex-wrap gap-x-8 gap-y-3 flex-1 min-w-0">
                        <div className="min-w-0">
                            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-0.5">Name</p>
                            <p className="text-sm m-0 truncate">{first_name} {last_name}</p>
                        </div>
                        <div className="min-w-0">
                            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-0.5">Email</p>
                            <p className="text-sm m-0 truncate">{email}</p>
                        </div>
                        {linkedin_profile_url && (
                            <div className="min-w-0">
                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-0.5">LinkedIn</p>
                                <a href={linkedin_profile_url} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline truncate block">
                                    Visit Profile
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    renderProfilePreview() {
        return (
            <div className="px-4">
                <ProfileReferenceRow reference={this.getModelFromProps()} />
            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};